module.exports = __webpack_public_path__ + "static/slider-2-4685cecfe8cc2d5f2fc7dbb572b62a38.png";